import { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@tonic/shared/components/ui";
import { PlusCircle, Upload, Download } from 'lucide-react';
import { ProductsTable } from './ProductsTable';
import { ProductsFilter } from './ProductsFilter';
import { useProducts } from '../../hooks/useProducts';
import { useImportProducts, useExportProducts } from '../../hooks/useProductImportExport';
import { PageTitle } from "@/components/ui/PageTitle";
import PropTypes from 'prop-types';

export function ProductsPage() {
  const [filters, setFilters] = useState({});
  const [sort, setSort] = useState();
  const { data: products, isLoading } = useProducts(filters, sort);
  const importMutation = useImportProducts();
  const exportMutation = useExportProducts();
  const fileInputRef = useRef(null);

  const handleSort = (column) => {
    setSort(prev => {
      if (prev?.field === column) {
        // Toggle direction if same column
        return {
          field: column,
          direction: prev.direction === 'asc' ? 'desc' : 'asc'
        };
      }
      // Default to ascending for new column
      return {
        field: column,
        direction: 'asc'
      };
    });
  };

  const handleExport = async () => {
    try {
      await exportMutation.mutateAsync();
      // TODO: Show success toast
    } catch (error) {
      console.error('Failed to export products:', error);
      // TODO: Show error toast
    }
  };

  const handleImport = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      await importMutation.mutateAsync(file);
      // TODO: Show success toast
    } catch (error) {
      console.error('Failed to import products:', error);
      // TODO: Show error toast
    }
  };

  const actions = (
    <div className="flex items-center gap-2">
      <Button variant="outline" onClick={handleImport}>
        <Upload className="h-4 w-4 mr-2" />
        Import
      </Button>
      <Button variant="outline" onClick={handleExport}>
        <Download className="h-4 w-4 mr-2" />
        Export
      </Button>
      <Link to="/admin/products/new">
        <Button>
          <PlusCircle className="h-4 w-4 mr-2" />
          New Product
        </Button>
      </Link>
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept=".csv"
        className="hidden"
      />
    </div>
  );

  return (
    <div className="space-y-6">
      <PageTitle
        title="Products"
        description="Manage your product catalog"
        actions={actions}
      />
      
      <ProductsFilter filters={filters} onFilterChange={setFilters} />
      
      <ProductsTable
        products={products || []}
        onSort={handleSort}
        sortConfig={sort}
      />
    </div>
  );
}

ProductsPage.propTypes = {
  // No props needed as this is a page component
}; 